import React, { useState } from 'react'
import { connect } from 'react-redux'
import ModalWrapper from '../ModalWrapper'
import Button from '../../uiKit/Button'
import Icon from '../../misc/Icons'
import { verifyEmailOtp, resendEmailOtp } from '../../../actions/session'
import getErrorMessageForRequest from '../../../utils/getErrorMessageForRequest'
import useOtpDigits, { OTP_LENGTH } from '../../../utils/useOtpDigits'
import useResendCooldown from '../../../utils/useResendCooldown'

const RESEND_COOLDOWN_SEC = 30
const OTP_VALID_DURATION_MIN = 10

const EmailOtpModal = (props) => {
  const {
    hideModal, authFlow, email, verifyEmailOtp, resendEmailOtp,
  } = props
  const { code, getInputProps } = useOtpDigits({ onComplete: handleSubmitDigits })
  const [submitLoading, setSubmitLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [resendLoading, setResendLoading] = useState(false)
  const {
    resendCooldown, sentMessageVisible, startCooldown, clearCooldown,
  } = useResendCooldown()
  const [emailOtpEventId, setEmailOtpEventId] = useState(authFlow.emailOtpEventId)

  async function handleSubmitDigits(otpCode) {
    if (otpCode.length < OTP_LENGTH) return
    try {
      setSubmitLoading(true)
      setErrorMessage('')
      await verifyEmailOtp(emailOtpEventId, otpCode)
      hideModal()
    } catch (err) {
      setSubmitLoading(false)
      const message = getErrorMessageForRequest({
        requestName: 'verifyEmailOtp',
        response: err.response,
      })
      setErrorMessage(message)
    }
  }

  function handleSubmit(e) {
    e.preventDefault()
    handleSubmitDigits(code)
  }

  async function handleResend() {
    try {
      setResendLoading(true)
      clearCooldown()
      setErrorMessage('')
      const response = await resendEmailOtp(
        authFlow.id,
        { token: authFlow.token },
      )
      const emailOtpStep = response.nextSteps?.find((it) => it.eventName === 'email-otp')
      setEmailOtpEventId(emailOtpStep.eventId)
      startCooldown(RESEND_COOLDOWN_SEC)
    } catch (err) {
      const message = getErrorMessageForRequest({
        requestName: 'resendEmailOtp',
        response: err.response,
      })
      setErrorMessage(message)
    } finally {
      setResendLoading(false)
    }
  }

  return (
    <div className='emailOtp-modalContainer marketing'>
      <ModalWrapper
        hideModal={() => {}}
        closeBtn={false}
        cancelBtn={false}
        showModalHeader={false}
        modalStyle='dark'
      >
        <div className='emailOtp-modalContent'>
          <button
            type='button'
            className='emailOtp-modalContent-backBtn'
            onClick={hideModal}
          >
            ← Back
          </button>
          <div className='emailOtp-modalContent-iconBadge'>
            <Icon name='emailOtp' />
          </div>
          <div className='emailOtp-modalContent-title'>
            Verify your email
          </div>
          <div className='emailOtp-modalContent-description'>
            {'A verification code has been sent to your email '}
            <span className='emailOtp-modalContent-description-email'>{email}</span>
            <div className='emailOtp-modalContent-description-expiry'>
              This code expires in
              {' '}
              {OTP_VALID_DURATION_MIN}
              {' '}
              minutes.
            </div>
          </div>
          <form className='emailOtp-modalContent-main' onSubmit={handleSubmit}>
            <div className='emailOtp-modalContent-digitRow'>
              {Array.from({ length: OTP_LENGTH }, (_, index) => (
                // eslint-disable-next-line react/no-array-index-key, react/jsx-props-no-spreading
                <input key={index} className='emailOtp-modalContent-digitInput' {...getInputProps(index)} />
              ))}
            </div>
            {errorMessage && (
              <div className='emailOtp-modalContent-error'>
                {errorMessage}
              </div>
            )}
            <div className='emailOtp-modalContent-resend'>
              {sentMessageVisible && (
                <span className='emailOtp-modalContent-resend-success'>
                  Sent!
                </span>
              )}
              {!sentMessageVisible && resendCooldown > 0 && (
                <button type='button' className='emailOtp-modalContent-resend-btn' disabled>
                  {`Resend available in ${resendCooldown}s`}
                </button>
              )}
              {!sentMessageVisible && resendCooldown <= 0 && (
                <button
                  type='button'
                  className='emailOtp-modalContent-resend-btn'
                  onClick={handleResend}
                  disabled={resendLoading}
                >
                  {resendLoading ? 'Sending...' : 'Send a new code'}
                </button>
              )}
            </div>
            <Button
              size='large'
              color='blue'
              label='Continue'
              type='submit'
              submitLoading={submitLoading}
              onClickFunction={() => handleSubmit}
            />
          </form>
        </div>
      </ModalWrapper>
    </div>
  )
}

export default connect(
  () => ({}),
  { verifyEmailOtp, resendEmailOtp },
)(EmailOtpModal)
